import { register } from '../dispatcher';
import { ActionTypes } from '../constants/MogamboConstants';
import createStore from './StoreUtils';

/**
 * Business Store
 * All the store values that are related to bot responses are stored here
 * @type {[type]}
 */
const BusinessStore = createStore({
  _businessList: null,
  _botList: [],
  _templateBotList: [],
  _partnerIdMap: [],
  _testConfiguration: {},
  _isBusinessListLoading: true,

  resetData() {
    this._defaultBusinessTeamData = null;
    this._allTeams = [];
  },

  // Bot Metadata
  setBotList(botList) {
    this._botList = botList;
  },

  getBotList() {
    return this._botList || [];
  },

  setTemplateBotList(templateBotList) {
    this._templateBotList = templateBotList;
  },

  getTemplateBotList() {
    return this._templateBotList;
  },

  // Partner/Client Data
  setPartnerIdMap(partnerIdMap) {
    this._partnerIdMap = partnerIdMap;
  },

  getPartnerIdMap() {
    return this._partnerIdMap || {};
  },

  getPartnerNameList() {
    return Object.values(this._partnerIdMap);
  },

  // Bot Specific Test Configuration for JS-SDK
  setTestConfiguration(data) {
    this._testConfiguration = data;
  },

  getTestConfiguration() {
    return this._testConfiguration;
  },

  getTestConfigurationForBot() {
    return this._testConfiguration;
  },

  // Business data
  setBusinessList(businessList) {
    this._businessList = businessList.sort((business1, business2) => {
      return business1.viaName.toLowerCase() > business2.viaName.toLowerCase()
        ? 1
        : -1;
    });
  },

  toggleBusinessListLoading() {
    this._isBusinessListLoading = !this._isBusinessListLoading;
  },

  getBusinessList() {
    return this._businessList;
  },

  getBusinessListLoadingStatus() {
    return this._isBusinessListLoading;
  },

  getBusinessNameList() {
    return (this._businessList || []).map((business) => business.name);
  },

  setSupportedLanguages(supportedLanguages) {
    this._supportedLanguages = supportedLanguages;
  },

  getSupportedLanguages() {
    return this._supportedLanguages;
  },
});

BusinessStore.dispatchToken = register((action) => {
  const actionType = action.type;
  action = action.action;

  switch (actionType) {
    case ActionTypes.FETCH_BOT_TEST_CONFIG_SUCCESS:
      BusinessStore.setTestConfiguration(action.config);
      BusinessStore.emitChange();
      break;

    case ActionTypes.TOGGLE_BUSINESS_LIST_LOADING:
      BusinessStore.toggleBusinessListLoading();
      BusinessStore.emitChange();
      break;

    case ActionTypes.RECEIVED_BUSINESS_LIST:
      BusinessStore.setBusinessList(action.businessList);
      BusinessStore.setPartnerIdMap(action.meta.partnerIdMap);
      BusinessStore.setBotList(action.meta.domainList);
      BusinessStore.setSupportedLanguages(action.meta.languageList);
      BusinessStore.setTemplateBotList(action.meta.templateDomainList);
      BusinessStore.toggleBusinessListLoading();
      BusinessStore.emitChange();
      break;

    default:
      break;
  }
});

export default BusinessStore;
